import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-spinner-overlay',
  imports: [CommonModule],
  templateUrl: './spinner-overlay.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './spinner-overlay.css',
})
export class SpinnerOverlayComponent {
  @Input() visible = false;
  @Input() label = 'Chargement... so.ts:12';
}
